import { useState, useEffect } from "react";
import { 
  getAllProjects, 
  getAllMerchants, 
  createProVenMapping 
} from "../Api/ProVenMapping";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const ProVenMapping = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [mappingData, setMappingData] = useState({
    projectCode: "",
    projectName: "",
    vendorCode: "",
    vendorName: ""
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [projectsData, merchantsData] = await Promise.all([
          getAllProjects(),
          getAllMerchants()
        ]);
        setProjects(projectsData);
        setMerchants(merchantsData);
      } catch (error) {
        toast.error("🦄 Error loading data!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // When projectCode or vendorCode changes, update the corresponding name
    if (name === "projectCode") {
      const selectedProject = projects.find(p => p.prozmaPrId === value);
      setMappingData(prev => ({
        ...prev,
        projectCode: value,
        projectName: selectedProject ? selectedProject.prTitle : ""
      }));
    } else if (name === "vendorCode") {
      const selectedMerchant = merchants.find(m => m.merchantCode === value);
      setMappingData(prev => ({
        ...prev,
        vendorCode: value,
        vendorName: selectedMerchant ? selectedMerchant.merchantName : ""
      }));
    } else {
      setMappingData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Assuming you have the userName from your auth context or localStorage
      const userName = localStorage.getItem("userName") || "11"; // Fallback to "11" if not found
      await createProVenMapping(mappingData, userName);
      toast.success("🦄 Mapping Created Successfully");
      setMappingData({
        projectCode: "",
        projectName: "",
        vendorCode: "",
        vendorName: ""
      });
      navigate("/viewProVenMapping"); 
    } catch (error) {
      toast.error("🦄 Error creating mapping");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand"> 
          <Container fluid className="fields-container">
            <h2 className="fields-title">Project-Vendor Mapping</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Project Code <span className="text-red">**</span></Form.Label>
                    <Form.Select 
                      name="projectCode" 
                      value={mappingData.projectCode} 
                      onChange={handleChange} 
                      required
                    >
                      <option value="">Select Project Code</option>
                      {projects.map((project) => (
                        <option key={project.prozmaPrId} value={project.prozmaPrId}>
                          {project.prozmaPrId} - {project.prTitle}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Project Name</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="projectName" 
                      value={mappingData.projectName} 
                      readOnly 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Vendor Code <span className="text-red">**</span></Form.Label>
                    <Form.Select 
                      name="vendorCode" 
                      value={mappingData.vendorCode} 
                      onChange={handleChange} 
                      required
                    >
                      <option value="">Select Vendor Code</option>
                      {merchants.map((merchant) => (
                        <option key={merchant.merchantCode} value={merchant.merchantCode}>
                          {merchant.merchantCode} - {merchant.merchantName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Vendor Name</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="vendorName" 
                      value={mappingData.vendorName} 
                      readOnly 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Mapping
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {/* Loader Overlay with Sample 14 */}
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ProVenMapping;